import * as React from "react";
const SvgProdukt = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 30.1 30.52",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 1" }, /* @__PURE__ */ React.createElement("rect", {
	width: 30.1,
	height: 16.78,
	y: 13.74,
	rx: 1.16
}), /* @__PURE__ */ React.createElement("rect", {
	width: 23.26,
	height: 3,
	x: 3.51,
	y: 6.87,
	rx: .43
}), /* @__PURE__ */ React.createElement("rect", {
	width: 15.92,
	height: 3,
	x: 7.18,
	rx: .36
}))));
export default SvgProdukt;
